import css from '@styled-system/css'
import * as React from 'react'
import styled, { StyledComponent, ThemeContext } from 'styled-components'
import {
  color,
  ColorProps,
  layout,
  LayoutProps,
  position,
  PositionProps,
  space,
  SpaceProps,
  typography,
  TypographyProps,
} from 'styled-system'

const SvgIcon = (
  props: React.SVGProps<SVGSVGElement> & {
    size?: number | string
    color?: string
  },
) => {
  const { size } = props

  if (size != null) {
    props = {
      width: size,
      height: size,
      ...props,
    }
  }

  const themeContext = React.useContext(ThemeContext)

  if (props.color != null) {
    props = { ...props, color: themeContext.colors[props.color] || props.color }
  }

  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 86 86"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#reservation_svg__clip0)">
        <path
          d="M57.19 41.423H13.846c-.66 0-1.29-.258-1.749-.717a2.472 2.472 0 01-.716-1.748c0-.66.258-1.29.716-1.749a2.472 2.472 0 011.75-.717H57.19c.66 0 1.29.259 1.749.717.458.459.716 1.09.716 1.749 0 .66-.258 1.29-.716 1.748a2.472 2.472 0 01-1.749.717zm-14.247 11.38H13.846c-.66 0-1.29-.257-1.749-.716a2.472 2.472 0 01-.716-1.748c0-.66.258-1.29.716-1.75a2.472 2.472 0 011.75-.716h29.067c.66 0 1.29.258 1.749.717.458.458.716 1.09.716 1.748 0 .66-.258 1.29-.716 1.75a2.456 2.456 0 01-1.72.716zM32.909 64.186H13.846c-.66 0-1.29-.259-1.749-.717a2.472 2.472 0 01-.716-1.749c0-.66.258-1.29.716-1.748a2.473 2.473 0 011.75-.717h19.062c.66 0 1.29.258 1.75.717.458.458.716 1.089.716 1.748 0 .66-.258 1.29-.717 1.749a2.472 2.472 0 01-1.749.716zm36.493-14.363v-38.04c0-.66-.258-1.29-.717-1.749a2.472 2.472 0 00-1.748-.716H55.155V2.465c0-.315-.058-.66-.2-.946a2.493 2.493 0 00-.546-.802 2.646 2.646 0 00-.802-.545 2.66 2.66 0 00-.946-.2c-.316 0-.66.057-.946.2a2.492 2.492 0 00-.803.545c-.23.229-.401.487-.545.802-.114.287-.2.63-.2.946v6.852H20.84V2.465c0-.66-.258-1.29-.717-1.748A2.473 2.473 0 0018.375 0c-.659 0-1.29.258-1.748.717a2.473 2.473 0 00-.717 1.748v6.852H4.128c-.66 0-1.29.258-1.749.716a2.472 2.472 0 00-.716 1.749v64.184c0 .66.258 1.29.716 1.75.459.458 1.09.716 1.749.716h47.243c3.325 4.558 8.686 7.54 14.763 7.54 10.062 0 18.232-8.17 18.232-18.233 0-8.915-6.479-16.369-14.964-17.917zm-4.93-35.546v8.915H6.592v-8.915h57.878zM6.592 73.53V28.122h57.878v21.471c-9.288.831-16.598 8.657-16.598 18.175 0 2.007.344 3.956.946 5.762H6.593zm70.578 1.605a13.294 13.294 0 01-5.963 4.902 13.3 13.3 0 01-7.683.745 13.35 13.35 0 01-6.822-3.64 13.35 13.35 0 01-3.64-6.823 13.3 13.3 0 01.744-7.683 13.294 13.294 0 014.902-5.962 13.276 13.276 0 017.396-2.236c3.526 0 6.91 1.404 9.403 3.898a13.302 13.302 0 013.899 9.403c0 2.637-.774 5.218-2.236 7.396zm-3.784-3.411h-7.282c-.659 0-1.29-.258-1.748-.717a2.473 2.473 0 01-.717-1.749v-8.37c0-.66.258-1.29.717-1.749a2.472 2.472 0 011.748-.717c.66 0 1.29.259 1.75.717.458.459.716 1.09.716 1.749v5.905h4.816c.66 0 1.29.258 1.748.717.46.459.717 1.09.717 1.748 0 .66-.258 1.29-.717 1.75a2.472 2.472 0 01-1.748.716z"
          fill={props.color || '#000'}
        />
      </g>
      <defs>
        <clipPath id="reservation_svg__clip0">
          <path fill="#fff" d="M0 0h86v86H0z" />
        </clipPath>
      </defs>
    </svg>
  )
}

type StyledSystemProps = TypographyProps &
  SpaceProps &
  LayoutProps &
  ColorProps &
  PositionProps

const _style = (
  component: React.FC,
): StyledComponent<
  React.FC<
    React.SVGProps<SVGSVGElement> & {
      size?: number | string
      color?: string
    }
  >,
  Record<string, unknown>,
  StyledSystemProps,
  never
> => {
  const styledSystemProps = [typography, space, layout, color, position]
  return styled(component)(css({}), styledSystemProps)
}

const SvgReservation = _style(SvgIcon)

export default SvgReservation
